import Collection from '../collection';
import Contract from '../model/contract';





export default Collection.extend( {
	endpoint: 'contracts/list?apiVersion=2.0',
	responseAt: 'items',
    model: Contract
} );


// WEBPACK FOOTER //
// ./src/js/collection/contracts.js